import { useIntl } from "react-intl";
import { useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../redux/MemberAction";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import { Modal } from "../../common/Modal";
import { useAuth } from "../../auth/components/AuthInit";
import { CreateMemberForm } from "./CreateMemberForm";

export const CreateMemberDialog = ({ setSwalProps, currentAgentId }) => {
  const intl = useIntl();
  const formikRef = useRef();
  const dispatch = useDispatch();
  const dismissBtnRef = useRef();
  const { auth, saveAuth } = useAuth();
  const memberState = useSelector(({ member }) => member, shallowEqual);

  const saveValues = (queryParams) => {
    dispatch(actions.createMemberList(queryParams)).then((resp) => {
      resp = resp.data;

      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        setSwalProps({
          show: true,
          icon: "success",
          title: intl.formatMessage({ id: "success" }),
          text: intl.formatMessage({ id: "createMemberSuccess" }),
          onConfirm: () => {
            formikRef.current.resetForm();
            dismissBtnRef.current.click();
            window.location.reload();
            const queryParams = {
              action: "agentmemberlist",
              selagentid: auth.agentid,
              agentpagenum: "0",
              memberpagenum: "0",
            };
            dispatch(actions.callMemberList(queryParams));
          },
        });
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <Modal
        modalId="addMemberModal"
        title={intl.formatMessage({ id: "createMember" })}
        dismissBtnRef={dismissBtnRef}
      >
        <div className="p-3 custom-border-bottom">
          <CreateMemberForm formikRef={formikRef} saveValues={saveValues} />
        </div>
        <div className="p-3 d-flex justify-content-end align-items-center">
          {memberState.actionsLoading && (
            <div
              className="spinner-border me-2"
              role="status"
              style={{ scale: "0.55" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          )}
          <button
            type="button"
            disabled={memberState.actionsLoading}
            className="btn btn-primary px-3"
            onClick={() => formikRef.current.submitForm()}
          >
            {intl.formatMessage({ id: "create" })}
          </button>
        </div>
      </Modal>
    </div>
  );
};
